module.exports = __webpack_public_path__ + "static/media/manzo_06_thumb.fcf1814b.png";